import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Membership from "@/pages/Membership";
import Leaders from "@/pages/Leaders";
import Events from "@/pages/Events";
import About from "@/pages/About";
import Apply from "@/pages/Apply";
import WorkPage from "@/pages/WorkPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/blog/BlogPost";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout({ children }) {
  const { pathname } = useLocation();
  const hideChrome = false;
  return (
    <>
      {!hideChrome && <Navbar />}
      <main className={hideChrome ? "" : "pt-20 md:pt-24"}>
        {children}
      </main>
      {!hideChrome && <Footer />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
    <div className="App min-h-screen bg-[#0a0a0a] ink">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/leaders" element={<Leaders />} />
            <Route path="/events" element={<Events />} />
            <Route path="/about" element={<About />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/work" element={<WorkPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
        </Layout>
        <Toaster theme="light" position="bottom-right" />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}
export default App;
